import { useState, useRef, useCallback } from "react";
import { ClickPosition, CropState } from "../types";

/**
 * Custom hook to manage VLCropper internal state
 */
export const useCropperState = () => {
  const [clickPosition, setClickPosition] = useState<ClickPosition | null>(
    null,
  );
  const [isFullCrop, setIsFullCrop] = useState(false);
  const [hasInitialCrop, setHasInitialCrop] = useState(false);
  const [lastClickPosition, setLastClickPosition] =
    useState<ClickPosition | null>(null);

  // Refs for immediate access during events
  const lastClickPositionRef = useRef<ClickPosition | null>(null);
  const cropStartDataRef = useRef<CropState | null>(null);

  const updateClickPosition = useCallback((position: ClickPosition | null) => {
    setClickPosition(position);
    setLastClickPosition(position);
    lastClickPositionRef.current = position;
  }, []);

  const storeCropStartState = useCallback((cropState: CropState) => {
    cropStartDataRef.current = cropState;
  }, []);

  const resetState = useCallback(() => {
    setIsFullCrop(false);
    setHasInitialCrop(false);
    setClickPosition(null);
    setLastClickPosition(null);
    lastClickPositionRef.current = null;
    cropStartDataRef.current = null;
  }, []);

  return {
    // State
    clickPosition,
    isFullCrop,
    hasInitialCrop,
    lastClickPosition,

    // Refs
    lastClickPositionRef,
    cropStartDataRef,

    // Actions
    setClickPosition,
    setIsFullCrop,
    setHasInitialCrop,
    updateClickPosition,
    storeCropStartState,
    resetState,
  };
};
